import {backendUrl, refreshTokenEndpoint} from '../common/constants/endpoints';
import {buildQueryString, FetchResponse} from '../common/services/api';
import {Session, useAuthStore} from '../common/stores/useAuthStore';

// The screens load several lists at once; with an expired token each request
// would refresh on its own, sending the same refresh token several times
// (a rotated token used twice can be rejected and sign the admin out). They
// share one refresh instead.
let pendingRefresh: Promise<string | undefined> | null = null;

const refreshSession = (
  session: Session,
  headers: Record<string, string>,
): Promise<string | undefined> => {
  if (!pendingRefresh) {
    pendingRefresh = (async () => {
      const queryString = buildQueryString({
        accessToken: session.accessToken || '',
        refreshToken: session.refreshToken,
      });
      const url = `${backendUrl}${refreshTokenEndpoint}${queryString}`;
      const response = await fetch(url, {headers: {...headers}, method: 'GET'});
      const refreshSessionResponse: FetchResponse<Session> =
        await response.json();

      const {setSession, clearSession} = useAuthStore.getState();
      if (refreshSessionResponse?.data?.accessToken) {
        setSession(refreshSessionResponse.data);
        return refreshSessionResponse.data.accessToken;
      }
      clearSession();
      return undefined;
    })().finally(() => {
      pendingRefresh = null;
    });
  }
  return pendingRefresh;
};

const getFetchHeaders = async (
  bypassAuth = false,
  forcedAccess_token: string | null = null,
) => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Accept-Encoding': 'gzip, deflate, br',
    Connection: 'keep-alive',
    'ngrok-skip-browser-warning': '69420',
    'User-Agent': 'PostmanRuntime/7.28.4',
    'Access-Control-Allow-Origin': '*',
  };

  const session = useAuthStore.getState().session;
  let access_token = session?.accessToken;
  // *1000 because the expires_at is in seconds and Date.now() returns milliseconds
  // time spend on this 30 mins

  if (session?.expiresAt && session.expiresAt * 1000 < Date.now()) {
    access_token = await refreshSession(session, headers);
  }

  if ((forcedAccess_token || access_token) && !bypassAuth) {
    headers['Authorization'] = `Bearer ${forcedAccess_token ?? access_token}`;
  }

  return headers;
};

export default getFetchHeaders;
